module.exports = __webpack_public_path__ + "img/icon-close.93b99b17.svg";